import colorString from './color/colorString';
import rgb from './color/rgb';
export default function normalize(color) {
  return colorString(rgb(color));
}